<template>
  <section
    v-if="generation || connectionError"
    class="document-progress"
    :class="{ 'document-progress-error': failed }"
    aria-live="polite"
    aria-atomic="true"
    :aria-busy="generation && generation.status === 'running'"
  >
    <p v-if="title" class="document-progress-title">{{ title }}</p>
    <div class="document-progress-heading">
      <p>{{ label }}</p>
      <span v-if="generation && generation.total > 0">{{ percentage }}%</span>
    </div>
    <ProgressBar
      v-if="generation && generation.total > 0"
      :value="percentage"
      :showValue="false"
      aria-label="Progreso de generación de documentos"
    />
    <ProgressBar
      v-else-if="generation && generation.status === 'running'"
      mode="indeterminate"
      aria-label="Preparando generación de documentos"
    />
    <p v-if="generation && generation.total > 0" class="document-progress-detail">
      {{ generation.completed }} de {{ generation.total }} documentos generados y guardados.
    </p>
    <p v-if="generation && generation.current" class="document-progress-detail">
      {{ generation.current }}
      <span v-if="generation.attempt > 1">
        · Intento {{ generation.attempt }} de {{ generation.maxAttempts }}
      </span>
    </p>
    <p v-if="failed" class="document-progress-detail" role="alert">
      {{ generation.error || 'Podés volver a intentar la generación.' }}
    </p>
    <p v-if="connectionError" class="document-progress-detail" role="status">
      {{ connectionError }}
    </p>
    <p v-else-if="generation && generation.status === 'running'" class="document-progress-detail">
      El proceso continúa en el servidor. El avance se actualiza automáticamente.
    </p>
  </section>
</template>

<script>
import { computed } from "vue";
import ProgressBar from "primevue/progressbar";
import { generationLabel, generationPercentage } from "../../utils/closureProgress";

export default {
  components: { ProgressBar },
  props: {
    generation: { type: Object, default: null },
    connectionError: { type: String, default: "" },
    title: { type: String, default: "" },
  },
  setup(props) {
    return {
      label: computed(() => generationLabel(props.generation) || "Consultando el estado…"),
      percentage: computed(() => generationPercentage(props.generation)),
      failed: computed(() => ["failed", "interrupted"].includes(props.generation?.status)),
    };
  },
};
</script>

<style scoped>
.document-progress {
  width: 100%;
  max-width: 640px;
  margin: 1.25rem auto;
  padding: 1rem;
  border: 1px solid var(--primary);
  border-radius: 0.5rem;
  background: var(--primary-light);
  color: var(--primary-dark);
}
.document-progress-error {
  border-color: var(--danger);
  background: #fff5f5;
}
.document-progress-title { margin-bottom: 0.6rem; font-weight: bold; }
.document-progress-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  margin-bottom: 0.75rem;
  font-weight: bold;
}
.document-progress-detail { margin-top: 0.6rem; overflow-wrap: anywhere; }
.document-progress :deep(.p-progressbar) { height: 0.65rem; background: white; }
.document-progress :deep(.p-progressbar-value) { background: var(--primary); }
.document-progress-error :deep(.p-progressbar-value) { background: var(--danger); }
</style>
